import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import dayTimezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(dayTimezone);

export const getReadableDateFormat = ({
  uses24hTime,
  scheduledAt,
  timezone,
}) => {
  const date = new Date(scheduledAt * 1000);
  const scheduledAtMoment = dayjs.tz(date, timezone);
  const readableFormat = uses24hTime ? 'MMM D, H:mm' : 'MMM D, h:mm A';
  return scheduledAtMoment.format(readableFormat);
};

export const getMomentTime = ({ scheduledAt, timezone }) => {
  const scheduledAtTime = scheduledAt || Date.now();
  let scheduledAtMoment = dayjs.unix(scheduledAtTime);
  if (timezone) {
    scheduledAtMoment = scheduledAtMoment.tz(timezone);
  }
  return scheduledAtMoment;
};

export const getTodayTimestamp = ({ timezone }) => {
  const todayDate = new Date().setSeconds(0);
  const isTimezoneSet = !!timezone;
  const today = isTimezoneSet
    ? dayjs.tz(todayDate, timezone)
    : dayjs(todayDate);
  return today.clone().add(1, 'hours').unix();
};
